export default class ExpandCustomerActivity {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    let currentCustomerId = this.context.stores.currentLocation.get().customerId;
    this.context.analytics.track('ExpandCustomerActivity', { customerId: currentCustomerId, ...attrs });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/expand_customer_activity.js